import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface BankTransactionErrorCardProps {
  title: string;
  message: string;
  onRetry?: () => void;
}

const BankTransactionErrorCard: React.FC<BankTransactionErrorCardProps> = ({
  title,
  message,
  onRetry,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="max-w-md w-full bg-white rounded-2xl shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-red-600 mb-2">{title}</h1>
            <div className="text-red-600 text-lg break-words">
              <div dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BankTransactionErrorCard;
